import React from 'react';
import PropTypes from 'prop-types';
import BannerMessage from '../../banner-message';
import GridColumns from '../../grid-columns';
import FuelTypePropType from '../../../utils/prop-types/fuel-type';
import ToggleIcon from '../../toggle-icon';

const { sortByFuelTypes } = require('../../../../lib/bputils').default;

class FuelTypesViewContent extends React.Component {
  static propTypes = {
    fuelTypes: PropTypes.arrayOf(FuelTypePropType).isRequired,
  };

  shouldComponentUpdate() {
    return false;
  }

  render = () => {
    const { fuelTypes } = this.props;

    if (!fuelTypes || !fuelTypes.length) {
      return (<BannerMessage message="PLEASE UPDATE YOUR STATION FUEL TYPES" />);
    }

    const sortedSelectedFuelTypes = sortByFuelTypes(fuelTypes);

    return (
      <GridColumns contents={(
        sortedSelectedFuelTypes.map(fueltype => ({
          key: fueltype.id,
          body: (
            <ToggleIcon
              key={fueltype.id}
              value={fueltype.id}
              name={fueltype.display_name}
              imageName={fueltype.id}
              imagePath="/images/stationProfile/v2/"
            />),
        })))}
      />
    );
  }
}

export default FuelTypesViewContent;
